const PAGE_STATE_PREFIX = 'learn-front-page-state:'

function getStorageKey(key) {
  return `${PAGE_STATE_PREFIX}${key}`
}

export function savePageState(key, payload) {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return
  }

  try {
    window.sessionStorage.setItem(getStorageKey(key), JSON.stringify({
      payload,
      updatedAt: Date.now()
    }))
  } catch (error) {
    console.warn('savePageState failed:', error)
  }
}

export function consumePageState(key) {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null
  }

  const storageKey = getStorageKey(key)

  try {
    const rawValue = window.sessionStorage.getItem(storageKey)
    if (!rawValue) {
      return null
    }

    window.sessionStorage.removeItem(storageKey)
    const parsed = JSON.parse(rawValue)
    return parsed && parsed.payload ? parsed.payload : null
  } catch (error) {
    window.sessionStorage.removeItem(storageKey)
    console.warn('consumePageState failed:', error)
    return null
  }
}

export function restoreWindowScroll(scrollTop) {
  if (typeof window === 'undefined') {
    return
  }

  const targetTop = Number.isFinite(scrollTop) ? scrollTop : 0

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      window.scrollTo(0, targetTop)
    })
  })
}
